function chkReqFields(f) {
    var form = typeof f === "string" ? $("#"+f) : $(f),
        chk = true,
        chkbox = true,
        aNumber = true;
    
    form.find(".required").each(function() {
        var $inp = $(this),
            type = $inp.attr("type"),
            val = $inp.val();
        
        if (type === "checkbox") {
            if($(this).prop("checked")) {
                $("input.required.alert-o").removeClass("alert-o");
                chkbox = true;
                return false;
            } else {
                $(this).addClass("alert-o");
                chkbox = false;
            }
        }
        else if (type === "number" || $inp.hasClass("inp-num")) {
            var x = parseInt(val),
                minX = $inp.attr("min") ? $inp.attr("min") : 0;
                
            if (isNaN(x) || x < minX || /\D/.test(x)) {
                $inp.addClass("alert");
                $inp.blur(chkDigitField);
                aNumber = false;
            } else {
                $inp.removeClass("alert");
            }
        }
        else {
            $inp.val(val.trim());
            val = val.replace(/\s/g, "");
            if(val === "" && val.length === 0 || type === "email" && !val.match(/\w@\w/)) {
                $inp.addClass("alert");
                $inp.blur(chkAlertField);
                chk = false;
            } else {
                $inp.removeClass("alert");
            }
        }
    });
    form.find(".derequired").each(function() {
        var $inp = $(this);
        $inp.removeClass("alert");
    });
    form.find(".errmsg-emptyfields").css("display" , chk ? "none" : "block");
    form.find(".errmsg-agree").css("display" , chkbox ? "none" : "block");
    
    return chk && chkbox && aNumber;
}
function chkDigitField(e) {
    var $field = $(e.currentTarget || e.target || e.srcElement),
        val = parseInt($field.val());
    
    if(!(isNaN(val) && /\D/.test(val))) {
        $field.removeClass("alert");
        $field.off(e.type);
    }
}
function chkAlertField(e) {
    var $field = $(e.currentTarget || e.target || e.srcElement),
        val = $field.val().replace(/\s/g, "");
    
    if(val !== "" && val.length !== 0) {
        $field.removeClass("alert");
        $field.off(e.type);
    }
}
function chkForm(id) {
    if(chkReqFields(id)) {
        document.getElementById(id).submit();
    }
}
function chkFormO(form) {
    if (chkReqFields(form)) {
        form.submit();
    }
}
function chkContactForm(nfields) {
    if (chkReqFields("#contactForm-Container")) {
        sendContactFormEmail(false, nfields);
    }
}

function checkInputs(page) {
    $('.inputField', page).each(function() {
        if ( $(this).val().trim() !== '' ) {
            $(this).parent().addClass('filled');
        }
    });
    $('.inputField', page).focus(function() {
        $(this).parent().addClass('filled');
    }).focusout(function() {
        if($(this).hasClass('datePicker_input')){
            return false;
        }else if($(this).val().trim() === ''){
            $(this).parent().removeClass('filled');
        } 
    });
}

function toggleRequiredField(ctnId, fieldId, on) {
    var ctn = document.getElementById(ctnId);
    var field = document.getElementById(fieldId);
    var extra = document.getElementById("bigfield_volunteer");
    
    if (on) {
        ctn.style.display = "block";
        $(field).addClass("required");
    } else {
        ctn.style.display = "none";
        $(field).removeClass("required");
        field.value = "";
    }
    if (extra) {
        extra.style.display = on ? "block" : "none";
    }
}